import axios from "axios";
import { API_BASE_URL, API_HEADERS } from "./apiConfig";

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    ...API_HEADERS,
    "Content-Type": "application/json",
  },
});

// Request interceptor
httpClient.interceptors.request.use(
  (config) => {
    // Add headers to every request
    config.headers = {
      ...config.headers,
      ...API_HEADERS,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
httpClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors here if needed
    return Promise.reject(error);
  }
);

export default httpClient;

